import { doGet, doPut, doPost, doDelete } from './common';

const getList = (pagination = undefined, sort = undefined, keyword = undefined) => {
  let filter = '';
  if (pagination) {
    filter = `?limit=${pagination.limit}&offset=${pagination.offset}`;
  }
  if (sort) {
    if (filter !== '') filter += `&sort=${sort}`;
    else filter = `?sort=${sort}`;
  }
  if (keyword) {
    if (filter !== '') filter += `&keyword=${keyword}`;
    else filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/supplier${filter}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getStatYear = (id, year) => {
  return doGet(`/api/supplier/${id}/stat/${year}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}
const getListCount = (keyword) => {
  let filter = '';
  if (keyword) {
    filter = `?keyword=${keyword}`;
  }
  return doGet(`/api/supplier/count${filter}`).then(res => (res.data.count))
    .catch(err => { })
    .finally(() => {

    });
}

const getListEnabled = () => {
  return doGet(`/api/supplier`).then(res => (res.data.filter(x => x.enabled === true)))
    .catch(err => { })
    .finally(() => {

    });
}

const getById = (id) => {
  return doGet(`/api/supplier/${id}`)
    .catch(err => { })
    .finally(() => {

    });
}

const getByName = (name) => {
  return doGet(`/api/supplier/name/${name}`)
    .catch(err => { })
    .finally(() => {

    });
}

const insert = (params) => {
  return doPost(`/api/supplier`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const update = (id, params) => {
  return doPut(`/api/supplier/${id}`, params).then(res => (res.dat)
  ).catch(err => {

  }).finally(() => {

  });
}
const checkCanDelete = (id) => {
  return doGet(`/api/supplier/${id}/used`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const deleteById = (id) => {
  return doDelete(`/api/supplier/${id}`).then(data => (
    {

    }
  )).catch(err => {

  }).finally(() => {

  });
}

const insertGoods = (id, params) => {
  return doPost(`/api/supplier/${id}/goods`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const getGoodsList = (id) => {
  return doGet(`/api/supplier/${id}/goods`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getGoodsAndPriceList = (id) => {
  return doGet(`/api/supplier/${id}/goods/price/realtime`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getGoodsListByDatetime = (id, datetime) => {
  return doGet(`/api/supplier/${id}/goods/${datetime}`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getGoodsListByName = (name) => {
  return doGet(`/api/supplier/name/${name}/goods`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const checkCanDeleteGoods = (supplier_id, goods_id, goods_spec_id) => {
  return doGet(`/api/supplier/${supplier_id}/goods/${goods_id}/spec/${goods_spec_id}/used`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const deleteGoods = (supplier_id, goods_id, goods_spec_id) => {
  return doDelete(`/api/supplier/${supplier_id}/goods/${goods_id}/spec/${goods_spec_id}`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}
const getGoodsPriceList = (id) => {
  return doGet(`/api/supplier/${id}/goods/price`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const getGoodsSpecPriceList = (supplier_id, goods_id, goods_spec_id) => {
  return doGet(`/api/supplier/${supplier_id}/goods/${goods_id}/spec/${goods_spec_id}/price`).then(res => (res.data))
    .catch(err => { })
    .finally(() => {

    });
}

const insertGoodsPrice = (supplier_id, goods_id, goods_spec_id, params) => {
  return doPost(`/api/supplier/${supplier_id}/goods/${goods_id}/spec/${goods_spec_id}/price`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const updateGoodsPrice = (supplier_id, goods_id, goods_spec_id, params) => {
  return doPut(`/api/supplier/${supplier_id}/goods/${goods_id}/spec/${goods_spec_id}/price`, params).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const deleteGoodsPrice = (supplier_id, goods_id, goods_spec_id, start_time) => {
  return doDelete(`/api/supplier/${supplier_id}/goods/${goods_id}/spec/${goods_spec_id}/price/${start_time}`).then(res => (res.data)
  ).catch(err => {

  }).finally(() => {

  });
}

const downloadTemplate = () => {
  return doGet(`/api/supplier/template/download`, null, 'blob').then(res => (res.data))
  .catch(err => { })
  .finally(() => {

  });
}

const download = () => {
  return doGet(`/api/supplier/download`, null, 'blob').then(res => (res.data))
  .catch(err => { })
  .finally(() => {

  });
}

export {
  getList,
  getListCount,
  getListEnabled,
  getById,
  getByName,
  getGoodsListByName,
  update,
  insert,
  deleteById,
  checkCanDelete,
  getStatYear,
  insertGoods,
  deleteGoods,
  checkCanDeleteGoods,
  getGoodsList,
  getGoodsListByDatetime,
  getGoodsPriceList,
  getGoodsSpecPriceList,
  insertGoodsPrice,
  updateGoodsPrice,
  deleteGoodsPrice,
  downloadTemplate,
  download,
  getGoodsAndPriceList
}